import Http from "./Http";

export class FAQService extends Http {
  /**
   * Get list of FAQ's category
   * @param {Object} params
   * @param {boolean} params.limit
   * @param {boolean} params.offset
   * @param {boolean} params.q
   */
  getListFAQCategories(params) {
    return this.get("/faqs/categories", { params });
  }

  /**
   * Get FAQ's category items
   * @param {number} id
   * @param {Object} params
   * @param {boolean} params.limit
   * @param {boolean} params.offset
   */
  getFAQCategoryItems(id, params) {
    return this.get(`/faqs/categories/${id}/items`, { params });
  }
}

export default new FAQService();
